import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class OneIntro extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_flowering_2.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
        Part I: Preparing Your Grow
        </h2>
        <p>
        In Part I we’ll cover all the things you’ll need in order to grow marijuana successfully. Each section highlights a different variable that you should be mindful of during the growing process. Each of these variables is integral to maintaining a happy and healthy marijuana plant. Spend time setting up your grow space and buying the necessary items before planting. It is much easier to plan and control for each of these variables before your space is filled with plants.
        </p>
        <GuideButton slugTo="space" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/one_intro.js